import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'meetingTime'
})

export class MeetingTimePipe implements PipeTransform {
  transform(collection) {
    if (!collection) {
      return 0;
    }

    return Object.values(JSON.parse(collection)).join(', ');
  }
}
